module.exports = __webpack_public_path__ + "img/n2.813319ea.jpeg";